import Signin from "./pages/authentication/signin";
import EmplyoeeAdd from "./pages/Masters/EmployeeMaster/components/AddEmplyoee";
import ForgotPassword from "./pages/authentication/ForgotPassword";
import ResetPassword from "./pages/authentication/ResetPassword";
import Project from "./pages/Project";
import AddProject from "./pages/Project/components/AddProject";
import RoleCreate from "./pages/Identity/RoleCreate";
import RolePermission from "./pages/Identity/RolePermission";
import TaskCreationForm from "./pages/taskCreation/taskCreationForm";
import TaskBoardDrag from "./pages/taskBoard/taskBoardDrag";
import StakeHolder from "./pages/StakeHolder";
import StakeHolderView from "./pages/StakeHolder/StakeHolderView";
import TaskListView from "./pages/taskCreation/employeeApprove/TaskListView";
import NewTaskBoard from "./pages/taskBoard/NewTaskBoard";
import ViewProject from "./pages/Project/components/ViewProject";
import MileStone from "./pages/Project/Miletone";
import Module from "./pages/Project/Module";
import ProjectReportTabel from "./pages/reports/projectReports/projectReportTabel";
import ViewProjectReport from "./pages/reports/projectReports/viewProjectReport";
import AllProject from "./pages/AllProject";
import ViewAllTask from "./pages/taskCreation/allTask/ViewAllTask";
import PortfilioDetails from "./pages/AllProject/components/PortfilioDetails";
import Meetings from "./pages/Meetings/CreateMeeting";
import Portfolio from "./pages/Portfolio";
import Docunments from "./pages/Docunments";
import CreateMeeting from "./pages/Meetings/CreateMeeting/components";
import TaskFilter from "./pages/taskFilter";
import LandingPage from "./pages/authentication/landingPage";
import MeetingFilter from "./pages/Meetings/MeetingFilter";
import MomTask from "./pages/task/momTask";
import MomView from "./pages/task/momTask/component";
import Dashboards from "./pages/dashboards";
import ProjectDashboard from "./pages/HomeProjectDashboard";
import EmployeeDashboard from "./pages/EmployeeDashbaord";
import TestCaseCreation from "./pages/IssueTracker/TestcaseCreation";
import BugList from "./pages/IssueTracker/BugList";
import TaskBugList from "./pages/task/Bugs";
import ProjectInsights from "./pages/IssueTracker/Project_Insights";
import TestRun from "./pages/IssueTracker/Test_Run";
import TestPlans from "./pages/IssueTracker/Test_Plans";
import Reports from "./pages/IssueTracker/Reports";
import CreateTestRun from "./pages/IssueTracker/Test_Run/components/CreateTestRun";
import EmployeeMaster from './pages/Masters/EmployeeMaster/index'
import DepartmentMaster from './pages/Masters/DepartmentMaster/index'
import DesignationMaster from './pages/Masters/DesignationMaster/index'
import TeamMaster from './pages/Masters/TeamMaster/index'
import TaskCreationNew from "./pages/TaskCreationNew";
import TaskCreationList from "./pages/TaskCreationNew/components/TaskCreationList";
import EmployeeTask from "./pages/EmployeeTask";
import ApprovalMaster from "./pages/Masters/ApprovalMater";
import DashboardProject from "./pages/DashbaordProject";


const routes = [
  {
    name: "Authentication",
    key: "authentication",
    collapse: [
      {
        name: "Sign in",
        key: "sign-in",
        route: "/sign-in",
        component: <Signin />,
      },

      {
        name: "Forgot Password",
        key: "forgot-password",
        route: "/forgot-password",
        component: <ForgotPassword />,
      },
      {
        name: "Reset Password",
        key: "reset-password",
        route: "password-reset-confirm/:uidb64/:token",
        component: <ResetPassword />,
      },
    ],
  },

  {
    type: "collapse",
    icon: <svg width="20" height="20" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(0 0 0)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.60352 3.25C4.36088 3.25 3.35352 4.25736 3.35352 5.5V8.99998C3.35352 10.2426 4.36087 11.25 5.60352 11.25H9.10352C10.3462 11.25 11.3535 10.2426 11.3535 8.99998V5.5C11.3535 4.25736 10.3462 3.25 9.10352 3.25H5.60352ZM4.85352 5.5C4.85352 5.08579 5.1893 4.75 5.60352 4.75H9.10352C9.51773 4.75 9.85352 5.08579 9.85352 5.5V8.99998C9.85352 9.41419 9.51773 9.74998 9.10352 9.74998H5.60352C5.1893 9.74998 4.85352 9.41419 4.85352 8.99998V5.5Z" fill="#1e2a78" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.60352 12.75C4.36088 12.75 3.35352 13.7574 3.35352 15V18.5C3.35352 19.7426 4.36087 20.75 5.60352 20.75H9.10352C10.3462 20.75 11.3535 19.7426 11.3535 18.5V15C11.3535 13.7574 10.3462 12.75 9.10352 12.75H5.60352ZM4.85352 15C4.85352 14.5858 5.1893 14.25 5.60352 14.25H9.10352C9.51773 14.25 9.85352 14.5858 9.85352 15V18.5C9.85352 18.9142 9.51773 19.25 9.10352 19.25H5.60352C5.1893 19.25 4.85352 18.9142 4.85352 18.5V15Z" fill="#1e2a78" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8535 5.5C12.8535 4.25736 13.8609 3.25 15.1035 3.25H18.6035C19.8462 3.25 20.8535 4.25736 20.8535 5.5V8.99998C20.8535 10.2426 19.8462 11.25 18.6035 11.25H15.1035C13.8609 11.25 12.8535 10.2426 12.8535 8.99998V5.5ZM15.1035 4.75C14.6893 4.75 14.3535 5.08579 14.3535 5.5V8.99998C14.3535 9.41419 14.6893 9.74998 15.1035 9.74998H18.6035C19.0177 9.74998 19.3535 9.41419 19.3535 8.99998V5.5C19.3535 5.08579 19.0177 4.75 18.6035 4.75H15.1035Z" fill="#1e2a78" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.1035 12.75C13.8609 12.75 12.8535 13.7574 12.8535 15V18.5C12.8535 19.7426 13.8609 20.75 15.1035 20.75H18.6035C19.8462 20.75 20.8535 19.7426 20.8535 18.5V15C20.8535 13.7574 19.8462 12.75 18.6035 12.75H15.1035ZM14.3535 15C14.3535 14.5858 14.6893 14.25 15.1035 14.25H18.6035C19.0177 14.25 19.3535 14.5858 19.3535 15V18.5C19.3535 18.9142 19.0177 19.25 18.6035 19.25H15.1035C14.6893 19.25 14.3535 18.9142 14.3535 18.5V15Z" fill="#1e2a78" />
    </svg>
    ,
    name: "DashBoard",
    key: "dashboard",
    route: "/dashboard",
    component: <Dashboards />,
    noCollapse: true,
    protected: true,
    permissionModule: 'Dashboard'
  },
  {
    type: "collapse",
    icon: <svg width="20" height="20" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(0 0 0)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.60352 3.25C4.36088 3.25 3.35352 4.25736 3.35352 5.5V8.99998C3.35352 10.2426 4.36087 11.25 5.60352 11.25H9.10352C10.3462 11.25 11.3535 10.2426 11.3535 8.99998V5.5C11.3535 4.25736 10.3462 3.25 9.10352 3.25H5.60352ZM4.85352 5.5C4.85352 5.08579 5.1893 4.75 5.60352 4.75H9.10352C9.51773 4.75 9.85352 5.08579 9.85352 5.5V8.99998C9.85352 9.41419 9.51773 9.74998 9.10352 9.74998H5.60352C5.1893 9.74998 4.85352 9.41419 4.85352 8.99998V5.5Z" fill="#1e2a78" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.60352 12.75C4.36088 12.75 3.35352 13.7574 3.35352 15V18.5C3.35352 19.7426 4.36087 20.75 5.60352 20.75H9.10352C10.3462 20.75 11.3535 19.7426 11.3535 18.5V15C11.3535 13.7574 10.3462 12.75 9.10352 12.75H5.60352ZM4.85352 15C4.85352 14.5858 5.1893 14.25 5.60352 14.25H9.10352C9.51773 14.25 9.85352 14.5858 9.85352 15V18.5C9.85352 18.9142 9.51773 19.25 9.10352 19.25H5.60352C5.1893 19.25 4.85352 18.9142 4.85352 18.5V15Z" fill="#1e2a78" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8535 5.5C12.8535 4.25736 13.8609 3.25 15.1035 3.25H18.6035C19.8462 3.25 20.8535 4.25736 20.8535 5.5V8.99998C20.8535 10.2426 19.8462 11.25 18.6035 11.25H15.1035C13.8609 11.25 12.8535 10.2426 12.8535 8.99998V5.5ZM15.1035 4.75C14.6893 4.75 14.3535 5.08579 14.3535 5.5V8.99998C14.3535 9.41419 14.6893 9.74998 15.1035 9.74998H18.6035C19.0177 9.74998 19.3535 9.41419 19.3535 8.99998V5.5C19.3535 5.08579 19.0177 4.75 18.6035 4.75H15.1035Z" fill="#1e2a78" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.1035 12.75C13.8609 12.75 12.8535 13.7574 12.8535 15V18.5C12.8535 19.7426 13.8609 20.75 15.1035 20.75H18.6035C19.8462 20.75 20.8535 19.7426 20.8535 18.5V15C20.8535 13.7574 19.8462 12.75 18.6035 12.75H15.1035ZM14.3535 15C14.3535 14.5858 14.6893 14.25 15.1035 14.25H18.6035C19.0177 14.25 19.3535 14.5858 19.3535 15V18.5C19.3535 18.9142 19.0177 19.25 18.6035 19.25H15.1035C14.6893 19.25 14.3535 18.9142 14.3535 18.5V15Z" fill="#1e2a78" />
    </svg>
    ,
    name: 'Employee DashBoard',
    key: 'employee-dashboard',
    route: '/employee-dashboard',
    component: <EmployeeDashboard />,
    noCollapse: true,
    protected: true,
    permissionModule: 'Employee Dashboard'
  },
  {
    type: "collapse",
    icon: <svg width="20" height="20" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(0 0 0)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.77344 5.25C7.77344 4.00736 8.7808 3 10.0234 3H14.0234C15.2661 3 16.2734 4.00736 16.2734 5.25V6H19.2736C20.5163 6 21.5236 7.00736 21.5236 8.25V17.25C21.5236 18.4926 20.5163 19.5 19.2736 19.5H4.77344C3.5308 19.5 2.52344 18.4926 2.52344 17.25V8.25C2.52344 7.00736 3.5308 6 4.77344 6H7.77344V5.25ZM14.7734 5.25V6H9.27344V5.25C9.27344 4.83579 9.60922 4.5 10.0234 4.5H14.0234C14.4377 4.5 14.7734 4.83579 14.7734 5.25ZM4.77344 7.5H19.2736C19.6879 7.5 20.0236 7.83579 20.0236 8.25V10.5H14.605C14.3242 9.90876 13.7215 9.5 13.0234 9.5H11.0234C10.3253 9.5 9.72271 9.90876 9.44185 10.5H4.02344V8.25C4.02344 7.83579 4.35922 7.5 4.77344 7.5ZM9.44185 12H4.02344V17.25C4.02344 17.6642 4.35922 18 4.77344 18H19.2736C19.6879 18 20.0236 17.6642 20.0236 17.25V12H14.605C14.3242 12.5912 13.7215 13 13.0234 13H11.0234C10.3253 13 9.72271 12.5912 9.44185 12Z" fill="#1e2a78" />
    </svg>
    ,
    name: "Project",
    key: "project",
    collapse: [
      {
        name: "Project",
        key: "project",
        route: "/project-list",
        component: <Project />,
        permissionModule: 'Project',
      },
      {
        name: "MileStones",
        key: "mileStones",
        route: "/mileStones",
        component: <MileStone />,
        permissionModule: 'Milestone'
      },
      {
        name: "Modules",
        key: "modules",
        route: "/modules",
        component: <Module />,
        permissionModule: 'Module'
      },
    ],
  },
  {
    name: "Add Project",
    key: "add-project",
    route: "/project-list/add-project",
    component: <AddProject />,
    protected: true,
    permissionModule: 'Project',
  },
  {
    name: "Edit Portfolio",
    key: "edit-project",
    route: "/project-list/edit-project",
    component: <AddProject />,
    protected: true,
    permissionModule: 'Project',
  },
  {
    name: "ProjectDashboard",
    key: "ProjectDashboard",
    route: "/project-dashboard",
    // component: <ProjectDashboard />,
    component: <DashboardProject />,
    protected: true,
  },

  {
    name: "Landing Page",
    key: "landing-page",
    route: "/landing-page",
    component: <LandingPage />,
  },
  {
    name: "View Project",
    key: "view-project",
    route: "/project-list/view-project",
    component: <ViewProject />,
    protected: true,
  },
  {
    name: "View Portfolio",
    key: "view-project",
    route: "/project-list/view-protfolio",
    component: <ViewProject />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Masters",
    key: "masters",
    icon: <svg width="20" height="20" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(0 0 0)">
      <path d="M10.2736 3.75C10.2736 2.7835 11.0571 2 12.0236 2C12.9901 2 13.7737 2.7835 13.7737 3.75C13.7737 4.7165 12.9902 5.5 12.0237 5.5C11.0572 5.5 10.2736 4.7165 10.2736 3.75Z" fill="#1e2a78" />
      <path d="M10.5214 7.92722C10.1758 8.1822 9.91299 8.55497 9.71818 9.03302C9.56188 9.41661 9.1242 9.60086 8.74061 9.44455C8.35702 9.28824 8.17278 8.85057 8.32909 8.46698C8.59746 7.80838 9.00617 7.18115 9.63066 6.72029C10.2619 6.25443 11.0578 6 12.0236 6C12.9894 6 13.7853 6.25443 14.4166 6.72029C15.0411 7.18115 15.4498 7.80838 15.7182 8.46698C15.8745 8.85057 15.6902 9.28824 15.3067 9.44455C14.9231 9.60086 14.4854 9.41661 14.3291 9.03302C14.1343 8.55497 13.8714 8.1822 13.5259 7.92722C13.1872 7.67724 12.7147 7.5 12.0236 7.5C11.3326 7.5 10.8601 7.67724 10.5214 7.92722Z" fill="#1e2a78" />
      <path d="M5.21818 21.533C5.41299 21.055 5.67584 20.6822 6.02135 20.4272C6.36008 20.1772 6.83259 20 7.52364 20C8.21468 20 8.68719 20.1772 9.02592 20.4272C9.37143 20.6822 9.63428 21.055 9.82909 21.533C9.9854 21.9166 10.4231 22.1009 10.8067 21.9445C11.1902 21.7882 11.3745 21.3506 11.2182 20.967C10.9498 20.3084 10.5411 19.6812 9.91661 19.2203C9.28535 18.7544 8.48944 18.5 7.52364 18.5C6.55783 18.5 5.76192 18.7544 5.13066 19.2203C4.50617 19.6812 4.09746 20.3084 3.82909 20.967C3.67278 21.3506 3.85702 21.7882 4.24061 21.9445C4.6242 22.1009 5.06188 21.9166 5.21818 21.533Z" fill="#1e2a78" />
      <path d="M5.77364 16.25C5.77364 15.2835 6.55714 14.5 7.52364 14.5C8.49013 14.5 9.27374 15.2835 9.27374 16.25C9.27374 17.2165 8.49023 18 7.52374 18C6.55724 18 5.77364 17.2165 5.77364 16.25Z" fill="#1e2a78" />
      <path d="M14.2182 21.533C14.413 21.055 14.6758 20.6822 15.0214 20.4272C15.3601 20.1772 15.8326 20 16.5236 20C17.2147 20 17.6872 20.1772 18.0259 20.4272C18.3714 20.6822 18.6343 21.055 18.8291 21.533C18.9854 21.9166 19.4231 22.1009 19.8067 21.9445C20.1902 21.7882 20.3745 21.3506 20.2182 20.967C19.9498 20.3084 19.5411 19.6812 18.9166 19.2203C18.2853 18.7544 17.4894 18.5 16.5236 18.5C15.5578 18.5 14.7619 18.7544 14.1307 19.2203C13.5062 19.6812 13.0975 20.3084 12.8291 20.967C12.6728 21.3506 12.857 21.7882 13.2406 21.9445C13.6242 22.1009 14.0619 21.9166 14.2182 21.533Z" fill="#1e2a78" />
      <path d="M14.7736 16.25C14.7736 15.2835 15.5571 14.5 16.5236 14.5C17.4901 14.5 18.2737 15.2835 18.2737 16.25C18.2737 17.2165 17.4902 18 16.5237 18C15.5572 18 14.7736 17.2165 14.7736 16.25Z" fill="#1e2a78" />
      <path d="M9.91621 12.8505C9.55749 13.0576 9.43459 13.5163 9.64169 13.875C9.8488 14.2337 10.3075 14.3566 10.6662 14.1495L12.0232 13.366L13.3803 14.1495C13.739 14.3566 14.1977 14.2337 14.4048 13.875C14.6119 13.5163 14.489 13.0576 14.1303 12.8505L12.7736 12.0672L12.7736 10.5C12.7736 10.0858 12.4378 9.75 12.0236 9.75C11.6094 9.75 11.2736 10.0858 11.2736 10.5V12.0668L9.91621 12.8505Z" fill="#1e2a78" />
    </svg>
    ,
    collapse: [
      {
        name: "Employee Master",
        key: "employee-master",
        route: "/employee-master",
        component: <EmployeeMaster />,
        permissionModule: "Employee Master",
      },
      {
        name: "Department Master",
        key: "depatment-master",
        route: "/dashboards/department-master",
        component: <DepartmentMaster />,
        permissionModule: "Department Master",
      },
      {
        name: "Designation Master",
        key: "designation-master",
        route: "/designation-master",
        component: <DesignationMaster />,
        permissionModule: "Designation Master",
      },
      {
        name: "Team Master",
        key: "team-master",
        route: "/team-master",
        component: <TeamMaster />,
        permissionModule: "Team Master",
      },
      {
        name: "Approval Master",
        key: "approval-master",
        route: "/approval-master",
        component: <ApprovalMaster />,
        // permissionModule: "Approval Master",
      }
    ],
  },
  {
    type: "collapse",
    name: "Identity",
    key: "identity",
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(0 0 0)">
      <path d="M19.3776 12.9431C19.1911 12.9446 19.0083 12.8897 18.8525 12.7854C18.6968 12.6811 18.5752 12.5321 18.5031 12.3573C18.431 12.1826 18.4118 11.9901 18.4478 11.8041C18.4838 11.6182 18.5734 11.4475 18.7053 11.3135C18.8372 11.1795 19.0054 11.0884 19.1885 11.0519C19.3715 11.0153 19.5611 11.0348 19.7332 11.108C19.9052 11.1812 20.0519 11.3048 20.1546 11.463C20.2573 11.6211 20.3114 11.8067 20.3098 11.9962C20.3078 12.2467 20.209 12.4863 20.0346 12.6635C19.8602 12.8406 19.6242 12.941 19.3776 12.9431ZM10.2842 8.53485C10.4704 8.53331 10.6529 8.588 10.8085 8.69193C10.964 8.7959 11.0857 8.94444 11.158 9.11874C11.2303 9.293 11.25 9.48519 11.2146 9.67087C11.1792 9.85656 11.0903 10.0274 10.9592 10.1617C10.828 10.2959 10.6606 10.3876 10.478 10.4251C10.2955 10.4625 10.1061 10.4441 9.93394 10.3721C9.76178 10.3001 9.61451 10.1777 9.51089 10.0206C9.40728 9.86344 9.35196 9.67857 9.35196 9.48945C9.35196 9.23763 9.44992 8.99597 9.62453 8.81717C9.79913 8.63837 10.0363 8.53691 10.2842 8.53485ZM4.58366 6.02808C4.76771 6.02961 4.9472 6.08646 5.09949 6.19142C5.2518 6.29639 5.37009 6.44478 5.43951 6.61792C5.50887 6.79105 5.52624 6.98118 5.48944 7.16436C5.45259 7.34751 5.36324 7.51548 5.23252 7.64713C5.10184 7.77876 4.93573 7.86817 4.7551 7.90409C4.57447 7.94 4.38742 7.92079 4.21752 7.8489C4.04761 7.77703 3.90246 7.65568 3.80036 7.50012C3.69825 7.3446 3.64377 7.16186 3.64376 6.97492C3.64375 6.84993 3.66812 6.72617 3.71545 6.61078C3.76277 6.4954 3.83213 6.39069 3.91951 6.30265C4.00688 6.21464 4.11056 6.14506 4.22455 6.09791C4.33855 6.05079 4.46059 6.02708 4.58366 6.02808ZM15.2206 3.5291C15.4069 3.52756 15.5893 3.58223 15.7449 3.68619C15.9004 3.79014 16.0221 3.93868 16.0944 4.11297C16.1667 4.28726 16.1864 4.47943 16.151 4.66511C16.1156 4.85079 16.0267 5.02161 15.8956 5.15589C15.7644 5.29017 15.597 5.38184 15.4145 5.41932C15.2319 5.45677 15.0426 5.43834 14.8704 5.36632C14.6982 5.2943 14.5509 5.17197 14.4473 5.01482C14.3437 4.85768 14.2883 4.67281 14.2883 4.48369C14.2883 4.23185 14.3863 3.99022 14.5609 3.81142C14.7355 3.63262 14.9726 3.53114 15.2206 3.5291ZM21.8305 11.9962C21.8319 11.5357 21.7076 11.0838 21.4714 10.6907C21.2351 10.2976 20.8962 9.97867 20.4923 9.76939C20.0884 9.56009 19.6353 9.46861 19.1833 9.50509C18.7312 9.54157 18.2981 9.7046 17.9318 9.97604C17.5655 10.2475 17.2804 10.6167 17.1083 11.0428C16.9361 11.4689 16.8837 11.935 16.9567 12.3895C17.0297 12.8441 17.2253 13.2692 17.5218 13.6176C17.8183 13.966 18.2041 14.2241 18.6364 14.3633V15.6361C18.6364 15.8644 18.5921 16.0904 18.5061 16.3013C18.42 16.5123 18.294 16.7039 18.135 16.8653C17.9761 17.0268 17.7874 17.1548 17.5797 17.2422C17.372 17.3296 17.1494 17.3745 16.9247 17.3745H16.0153C15.0402 17.373 14.0978 17.7316 13.3637 18.3834C13.1525 17.5132 12.7264 16.7119 12.1258 16.0551C13.1637 16.0249 14.1491 15.5847 14.8725 14.8282C15.596 14.0717 16.0005 13.0585 16 12.004V6.85851C16.5545 6.67389 17.026 6.29458 17.3299 5.78871C17.6338 5.28281 17.7501 4.68347 17.6581 4.09828C17.5661 3.51309 17.2716 2.98039 16.8277 2.59582C16.3838 2.21125 15.8194 2 15.2359 2C14.6524 2 14.088 2.21125 13.6441 2.59582C13.2001 2.98039 12.9057 3.51309 12.8137 4.09828C12.7217 4.68347 12.838 5.28281 13.1419 5.78871C13.4458 6.29458 13.9173 6.67389 14.4718 6.85851V11.9807C14.4718 12.6476 14.2109 13.2872 13.7466 13.7587C13.2823 14.2303 12.6525 14.4952 11.9959 14.4952H10.5517C10.8745 13.9778 11.0443 13.3771 11.0407 12.7645V11.8565C11.5952 11.6719 12.0667 11.2926 12.3706 10.7867C12.6744 10.2808 12.7908 9.68148 12.6988 9.09627C12.6067 8.5111 12.3123 7.97839 11.8684 7.59382C11.4244 7.20925 10.86 6.99801 10.2766 6.99801C9.69307 6.99801 9.1287 7.20925 8.68475 7.59382C8.24084 7.97839 7.9464 8.5111 7.85436 9.09627C7.76232 9.68148 7.87867 10.2808 8.18258 10.7867C8.48646 11.2926 8.95794 11.6719 9.5124 11.8565V12.7645C9.51271 13.213 9.34161 13.6441 9.03513 13.9669C8.72865 14.2897 8.31079 14.4791 7.8695 14.4952C7.20946 14.4911 6.57779 14.2219 6.11248 13.7465C5.64716 13.271 5.38598 12.6278 5.38601 11.9574V9.342C5.94046 9.15738 6.41198 8.77806 6.71586 8.27217C7.01974 7.76627 7.13612 7.16692 7.04408 6.58175C6.95204 5.99658 6.6576 5.46387 6.21369 5.0793C5.76974 4.69473 5.20534 4.48348 4.62187 4.48348C4.03838 4.48348 3.474 4.69473 3.03006 5.0793C2.58612 5.46387 2.2917 5.99658 2.19966 6.58175C2.10762 7.16692 2.22399 7.76627 2.52788 8.27217C2.83177 8.77806 3.30326 9.15738 3.85772 9.342V11.9497C3.85968 13.0263 4.2796 14.0588 5.02638 14.8231C5.77312 15.5873 6.7865 16.0217 7.84657 16.0319H8.7559C9.19059 16.0373 9.61927 16.1355 10.0142 16.32C10.4091 16.5045 10.7615 16.7712 11.0484 17.1029C11.6702 17.7708 12.022 18.6517 12.0341 19.5708V22H13.5624V21.449C13.5624 20.7738 13.8265 20.1264 14.2965 19.649C14.7665 19.1716 15.4041 18.9034 16.0688 18.9034H16.9782C17.8334 18.9034 18.6536 18.5583 19.2584 17.9441C19.8631 17.33 20.2029 16.4969 20.2029 15.6283V14.3555C20.6864 14.1928 21.1081 13.8812 21.4094 13.4639C21.7106 13.0467 21.823 12.5136 21.8305 11.9962Z" fill="#1e2a78" />
    </svg>
    ,
    collapse: [
      {
        name: "Role Creation",
        key: "role-creation",
        route: "/role-creation",
        component: <RoleCreate />,
        permissionModule: "Role Creation",
      },
      {
        name: "Role Permission",
        key: "role-permission",
        route: "/role-permission",
        component: <RolePermission />,
        permissionModule: "Role Permission",
      },
    ],
  },
  {
    type: "collapse",
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(0 0 0)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9453 20.5C11.3327 21.0667 11.8027 21.5725 12.338 22H6.75C5.50736 22 4.5 20.9926 4.5 19.75V9.62105C4.5 9.02455 4.73686 8.45247 5.15851 8.03055L10.5262 2.65951C10.9482 2.23725 11.5207 2 12.1177 2H17.25C18.4926 2 19.5 3.00736 19.5 4.25V10.3782C19.0266 10.1599 18.5241 9.99391 18 9.88753V4.25C18 3.83579 17.6642 3.5 17.25 3.5H12.248L12.2509 7.4984C12.2518 8.74166 11.2442 9.75 10.0009 9.75H6V19.75C6 20.1642 6.33579 20.5 6.75 20.5H10.9453ZM10.7488 4.55876L7.05986 8.25H10.0009C10.4153 8.25 10.7512 7.91389 10.7509 7.49947L10.7488 4.55876Z" fill="#1e2a78" />
      <path d="M15.8751 14.9999C15.8751 14.5857 16.2109 14.2499 16.6251 14.2499C17.0393 14.2499 17.3751 14.5857 17.3751 14.9999V15.8749H18.2502C18.6644 15.8749 19.0002 16.2107 19.0002 16.6249C19.0002 17.0391 18.6644 17.3749 18.2502 17.3749H17.3751V18.25C17.3751 18.6643 17.0393 19 16.6251 19C16.2109 19 15.8751 18.6643 15.8751 18.25V17.3749H15C14.5858 17.3749 14.25 17.0391 14.25 16.6249C14.25 16.2107 14.5858 15.8749 15 15.8749H15.8751V14.9999Z" fill="#1e2a78" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.25 16.625C11.25 13.6565 13.6565 11.25 16.625 11.25C19.5935 11.25 22 13.6565 22 16.625C22 19.5935 19.5935 22 16.625 22C13.6565 22 11.25 19.5935 11.25 16.625ZM16.625 12.75C14.4849 12.75 12.75 14.4849 12.75 16.625C12.75 18.7651 14.4849 20.5 16.625 20.5C18.7651 20.5 20.5 18.7651 20.5 16.625C20.5 14.4849 18.7651 12.75 16.625 12.75Z" fill="#1e2a78" />
    </svg>
    ,
    name: "Task Creation",
    key: "task-creation",
    route: "/task-creation",
    component: <TaskCreationNew />,
    noCollapse: true,
    protected: true,
    permissionModule: "Task Creation",
  },
  {
    name: 'task-list',
    key: 'task-list',
    route: '/task-creation/task-list',
    component: <TaskCreationList />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Project statistics",
    key: "Project statistics",
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(0 0 0)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM11.2499 3.53264C6.90681 3.91238 3.5 7.55834 3.5 12C3.5 14.0772 4.24507 15.9803 5.48252 17.4567L11.2499 11.6893V3.53264ZM6.54318 18.5174C8.01963 19.7549 9.9228 20.5 12 20.5C15.4591 20.5 18.4356 18.4338 19.7626 15.4682L12.1988 12.8618L6.54318 18.5174ZM20.2512 14.05C20.4137 13.3935 20.5 12.7068 20.5 12C20.5 7.55828 17.0931 3.91228 12.7499 3.53263V11.4652L20.2512 14.05Z" fill="#1e2a78" />
    </svg>
    ,
    collapse: [
      {
        name: "Program",
        key: "all-project",
        route: "/all-project",
        component: <AllProject />,
        permissionModule: "Program",
      },
      {
        type: "collapse",
        icon: (
          <lord-icon
            src="https://cdn.lordicon.com/jqqjtvlf.json"
            trigger="hover"
            colors="primary:#5c6cbf"
            style={{ width: "20px", height: "20px" }}
          ></lord-icon>
        ),
        name: "Task Filter",
        key: "taskfilter",
        route: "/taskfilter",
        permissionModule: "Task Filter",
        component: <TaskFilter />,
        noCollapse: true,
        protected: true,
      },
      {
        name: "Project Report",
        key: "project-report",
        route: "/project-report",
        component: <ProjectReportTabel />,
        permissionModule: "Project Report",
      },
    ],
  },
  {
    name: "Portfolio Details",
    key: "portfolio-details",
    route: "/all-project/portfolio-details",
    component: <PortfilioDetails />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Portfolio",
    key: "portfolio",
    route: "/portfolio",
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(0 0 0)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6 4.5C4.75736 4.5 3.75 5.50736 3.75 6.75V15H2.75C2.49007 15 2.24867 15.1346 2.11201 15.3557C1.97536 15.5768 1.96293 15.8529 2.07918 16.0854L3.16459 18.2562C3.54572 19.0185 4.32481 19.5 5.17705 19.5H18.8229C19.6752 19.5 20.4543 19.0185 20.8354 18.2562L21.9208 16.0854C22.0371 15.8529 22.0246 15.5768 21.888 15.3557C21.7513 15.1346 21.5099 15 21.25 15H20.25V6.75C20.25 5.50736 19.2426 4.5 18 4.5H6ZM20.0365 16.5H3.96353L4.50623 17.5854C4.63328 17.8395 4.89297 18 5.17705 18H18.8229C19.107 18 19.3667 17.8395 19.4938 17.5854L20.0365 16.5ZM18.75 15V6.75C18.75 6.33579 18.4142 6 18 6H6C5.58579 6 5.25 6.33579 5.25 6.75V15H18.75Z" fill="#1e2a78" />
    </svg>
    ,
    component: <Portfolio />,
    noCollapse: true,
    protected: true,
    permissionModule: "Portfolio",
  },
  {
    type: "collapse",
    name: "Documents",
    key: "documents",
    route: "/documents",
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(0 0 0)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 6C2 4.75736 3.00736 3.75 4.25 3.75H8.5C9.2082 3.75 9.87508 4.08344 10.3 4.65L11.65 6.45C11.7916 6.63885 12.0139 6.75 12.25 6.75H19.75C20.9926 6.75 22 7.75736 22 9V18C22 19.2426 20.9926 20.25 19.75 20.25H4.25C3.00736 20.25 2 19.2426 2 18V6ZM4.25 5.25C3.83579 5.25 3.5 5.58579 3.5 6V18C3.5 18.4142 3.83579 18.75 4.25 18.75H19.75C20.1642 18.75 20.5 18.4142 20.5 18V9C20.5 8.58579 20.1642 8.25 19.75 8.25H12.25C11.5418 8.25 10.8749 7.91656 10.45 7.35L9.1 5.55C8.95836 5.36115 8.73607 5.25 8.5 5.25H4.25Z" fill="#1e2a78" />
    </svg>

    ,
    component: <Docunments />,
    noCollapse: true,
    protected: true,
    permissionModule: 'Documents'
  },
  {
    type: "collapse",
    name: " Issue Tracker",
    key: "issue-tracker",
    icon: <svg width="20" height="20" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(0 0 0)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.13354 2.07934C9.50403 1.8941 9.95453 2.04427 10.1398 2.41475L10.6825 3.50024L10.7007 3.50016H13.3466C13.3989 3.50016 13.451 3.50198 13.5027 3.50557L14.0481 2.41475C14.2334 2.04427 14.6839 1.8941 15.0544 2.07934C15.4248 2.26459 15.575 2.71509 15.3898 3.08557L14.8805 4.10404C15.0738 4.28408 15.2369 4.49958 15.359 4.74393L16.238 6.50191C17.4392 6.54884 18.3986 7.53746 18.3986 8.75016V9.48177L19.7955 9.03571C20.1901 8.9097 20.6121 9.12743 20.7381 9.52201C20.8641 9.9166 20.6464 10.3386 20.2518 10.4646L18.3986 11.0564V13.1252H20.0236C20.4379 13.1252 20.7736 13.461 20.7736 13.8752C20.7736 14.2894 20.4379 14.6252 20.0236 14.6252H18.3986V15.6252C18.3986 15.9799 18.3697 16.3279 18.3139 16.6669L20.2518 17.2857C20.6464 17.4117 20.8641 17.8337 20.7381 18.2283C20.6121 18.6229 20.1901 18.8406 19.7955 18.7146L17.8969 18.1083C16.9287 20.3955 14.6636 22.0002 12.0236 22.0002C9.3837 22.0002 7.11855 20.3955 6.15035 18.1083L4.25179 18.7146C3.85721 18.8406 3.43519 18.6229 3.30918 18.2283C3.18318 17.8337 3.40091 17.4117 3.79549 17.2857L5.73333 16.6669C5.67762 16.3279 5.64864 15.9799 5.64864 15.6252V14.6252H4.02364C3.60943 14.6252 3.27364 14.2894 3.27364 13.8752C3.27364 13.461 3.60943 13.1252 4.02364 13.1252H5.64864V11.0564L3.79549 10.4646C3.40091 10.3386 3.18318 9.9166 3.30918 9.52201C3.43519 9.12743 3.85721 8.9097 4.25179 9.03571L5.64864 9.48177V8.75016C5.64864 7.53746 6.60804 6.54884 7.80924 6.50191L8.68823 4.74393C8.83049 4.45942 9.02818 4.21402 9.26443 4.01817L8.79813 3.08557C8.61289 2.71509 8.76306 2.26459 9.13354 2.07934ZM14.5601 6.50016L14.0174 5.41475C13.8904 5.16067 13.6307 5.00016 13.3466 5.00016H10.7007C10.4166 5.00016 10.1569 5.16067 10.0299 5.41475L9.48716 6.50016H14.5601ZM7.89864 8.00016C7.48443 8.00016 7.14864 8.33595 7.14864 8.75016V15.6252C7.14864 18.3176 9.33125 20.5002 12.0236 20.5002C14.716 20.5002 16.8986 18.3176 16.8986 15.6252V8.75016C16.8986 8.33595 16.5629 8.00016 16.1486 8.00016H7.89864Z" fill="#1e2a78" />
    </svg>
    ,
    collapse: [
      {
        name: "Project Insights",
        key: "project-insights",
        route: "/project-insights",
        component: <ProjectInsights />,
        permissionModule: 'Project Insights',
      },
      {
        name: 'Test Plans',
        key: 'test-plans',
        route: '/test-plans',
        component: <TestPlans />,
        permissionModule: 'Test Plan'
      },
      {
        name: "Test Case",
        key: "test-case",
        route: "/test-case",
        component: <TestCaseCreation />,
        permissionModule: 'Test Case',
      },
      {
        name: 'Test Run',
        key: 'test-run',
        route: '/test-run',
        component: <TestRun />,
        permissionModule: 'Test Run',
      },
      {
        name: 'Reports',
        key: 'reports',
        route: '/test-report',
        component: <Reports />,
        permissionModule: 'Reports',
      },
      {
        name: "Bug List",
        key: 'bug-list',
        route: '/bug-list',
        component: <BugList />,
        permissionModule: 'Bug List'
      }
    ],
  },
  {
    name: "Create Test run",
    key: "create-test-run",
    route: "/test-run/create-test-run",
    component: <CreateTestRun />,
    protected: true,
  },
  {
    type: "collapse",
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(0 0 0)">
      <path d="M7.18535 12.75C7.18535 12.3082 7.54352 11.95 7.98535 11.95H7.99535C8.43718 11.95 8.79535 12.3082 8.79535 12.75C8.79535 13.1918 8.43718 13.55 7.99535 13.55H7.98535C7.54352 13.55 7.18535 13.1918 7.18535 12.75Z" fill="#1e2a78" />
      <path d="M7.98535 15.95C7.54352 15.95 7.18535 16.3082 7.18535 16.75C7.18535 17.1918 7.54352 17.55 7.98535 17.55H7.99535C8.43718 17.55 8.79535 17.1918 8.79535 16.75C8.79535 16.3082 8.43718 15.95 7.99535 15.95H7.98535Z" fill="#1e2a78" />
      <path d="M11.1951 12.75C11.1951 12.3082 11.5533 11.95 11.9951 11.95H12.0051C12.4469 11.95 12.8051 12.3082 12.8051 12.75C12.8051 13.1918 12.4469 13.55 12.0051 13.55H11.9951C11.5533 13.55 11.1951 13.1918 11.1951 12.75Z" fill="#1e2a78" />
      <path d="M11.9951 15.95C11.5533 15.95 11.1951 16.3082 11.1951 16.75C11.1951 17.1918 11.5533 17.55 11.9951 17.55H12.0051C12.4469 17.55 12.8051 17.1918 12.8051 16.75C12.8051 16.3082 12.4469 15.95 12.0051 15.95H11.9951Z" fill="#1e2a78" />
      <path d="M15.2049 12.75C15.2049 12.3082 15.5631 11.95 16.0049 11.95H16.0149C16.4567 11.95 16.8149 12.3082 16.8149 12.75C16.8149 13.1918 16.4567 13.55 16.0149 13.55H16.0049C15.5631 13.55 15.2049 13.1918 15.2049 12.75Z" fill="#1e2a78" />
      <path d="M16.0049 15.95C15.5631 15.95 15.2049 16.3082 15.2049 16.75C15.2049 17.1918 15.5631 17.55 16.0049 17.55H16.0149C16.4567 17.55 16.8149 17.1918 16.8149 16.75C16.8149 16.3082 16.4567 15.95 16.0149 15.95H16.0049Z" fill="#1e2a78" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.75 2.75C8.75 2.33579 8.41421 2 8 2C7.58579 2 7.25 2.33579 7.25 2.75V3.75H5.5C4.25736 3.75 3.25 4.75736 3.25 6V19C3.25 20.2426 4.25736 21.25 5.5 21.25H18.5C19.7426 21.25 20.75 20.2426 20.75 19V6C20.75 4.75736 19.7426 3.75 18.5 3.75H16.75V2.75C16.75 2.33579 16.4142 2 16 2C15.5858 2 15.25 2.33579 15.25 2.75V3.75H8.75V2.75ZM19.25 8.25V6C19.25 5.58579 18.9142 5.25 18.5 5.25H5.5C5.08579 5.25 4.75 5.58579 4.75 6V8.25H19.25ZM4.75 9.75H19.25V19C19.25 19.4142 18.9142 19.75 18.5 19.75H5.5C5.08579 19.75 4.75 19.4142 4.75 19V9.75Z" fill="#1e2a78" />
    </svg>

    ,
    name: "Meetings",
    key: "meetings",
    route: "/meetings",
    collapse: [
      {
        name: "Record Mom",
        key: "record-mom",
        route: "/record-mom",
        component: <Meetings />,
        permissionModule: 'Record Meetings',
      },
      {
        name: "Meeting Filter",
        key: "meeting-filter",
        route: "/meeting-filter",
        component: <MeetingFilter />,
        permissionModule: 'Meeting Filter',
      },
    ],
    protected: true,
  },
  {
    name: "AddMeeting",
    key: "add-meeting",
    route: "/record-mom/add-meeting",
    component: <CreateMeeting />,
    protected: true,
  },
  // {
  //   name:'View Meeting',
  //   key:'view-meeting',
  //   route: '/record-mom/view-meeting',
  //   component: <ViewMeeting />,
  //   protected: true
  // },
  {
    name: "ViewTask",
    key: "view-task",
    route: "/all-task/view-task",
    component: <ViewAllTask />,
    protected: true,
  },
  {
    name: "ViewReport",
    key: "view-report",
    route: "/project-report/view-report",
    component: <ViewProjectReport />,
    protected: true,
  },
  {
    name: "AddEmplyoee",
    key: "add-emplyoee",
    route: "/employee-master/add-emplyoee",
    component: <EmplyoeeAdd />,
    protected: true,
  },
  {
    name: "AddTaskCreation",
    key: "add-task-creation",
    route: "/task-creation/task-list/add-task-creation",
    component: <TaskCreationForm />,
    protected: true,
  },
  {
    name: "EditTaskCreation",
    key: "edit-task-creation",
    route: "/task-creation/edit-task-creation",
    component: <TaskCreationForm />,
    protected: true,
  },
  {
    name: "ViewTaskCreation",
    key: "view-task-creation",
    route: "/task-creation/view-task-creation",
    component: <TaskCreationForm />,
    protected: true,
  },

  {
    name: "Add",
    key: "add",
    route: "/task-board/add",
    component: <TaskBoardDrag />,
    protected: true,
  },
  {
    name: "drag-&-drop",
    key: "drag-&-drop",
    route: "/task-board/drag-&-drop",
    component: <NewTaskBoard />,
    protected: true,
  },

  {
    name: "View",
    key: "view",
    route: "/tasklist/view",
    component: <TaskListView />,
    protected: true,
  },

  {
    type: "collapse",
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(0 0 0)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4423 4.05183C13.4423 3.02111 14.2779 2.18555 15.3086 2.18555C16.3393 2.18555 17.1749 3.02111 17.1749 4.05183C17.1749 5.08254 16.3393 5.91811 15.3086 5.91811C14.2779 5.91811 13.4423 5.08254 13.4423 4.05183ZM15.3086 3.68555C15.1063 3.68555 14.9423 3.84954 14.9423 4.05183C14.9423 4.25412 15.1063 4.41811 15.3086 4.41811C15.5109 4.41811 15.6749 4.25412 15.6749 4.05183C15.6749 3.84954 15.5109 3.68555 15.3086 3.68555Z" fill="#1e2a78" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M21.6044 11.2659C21.0447 10.6311 20.0839 10.5508 19.4266 11.0839L16.8212 13.197C16.512 12.6632 15.9345 12.304 15.2732 12.304H12.6754C11.5119 11.8794 10.2262 11.8074 9.41278 11.8111C8.64057 11.8146 7.94114 12.1196 7.38764 12.5621L5.69546 13.9148C5.47206 13.789 5.18986 13.781 4.95173 13.9185L2.37513 15.4061C2.01641 15.6132 1.8935 16.0719 2.10061 16.4306L5.09928 21.6245C5.30638 21.9832 5.76508 22.1061 6.1238 21.899L8.7004 20.4114C9.01125 20.2319 9.14503 19.8635 9.04042 19.535L9.56527 19.0601C9.70317 18.9353 9.8825 18.8662 10.0685 18.8662H16.2417C16.8423 18.8662 17.4104 18.5933 17.7859 18.1245L21.6525 13.2959C22.1317 12.6974 22.1114 11.841 21.6044 11.2659ZM8.2864 18.1943L8.55886 17.9478C8.97255 17.5735 9.51056 17.3662 10.0685 17.3662H16.2417C16.3869 17.3662 16.5242 17.3002 16.615 17.1869L20.4816 12.3583C20.5053 12.3287 20.5043 12.2863 20.4792 12.2579C20.4515 12.2265 20.404 12.2225 20.3715 12.2489L16.5205 15.3723C16.1984 15.686 15.7583 15.8793 15.2732 15.8793H12.5383C12.1241 15.8793 11.7883 15.5435 11.7883 15.1293C11.7883 14.7151 12.1241 14.3793 12.5383 14.3793H15.2732C15.3195 14.3793 15.3633 14.3684 15.4021 14.3489C15.4102 14.3417 15.4184 14.3347 15.4269 14.3279L15.5 14.2686C15.5381 14.2198 15.5608 14.1584 15.5608 14.0917C15.5608 13.9328 15.432 13.804 15.2732 13.804H12.5912C12.4613 13.804 12.3365 13.7794 12.222 13.7358C11.296 13.3829 10.1887 13.3076 9.41955 13.3111C9.04628 13.3128 8.66549 13.4609 8.32425 13.7337L6.53627 15.163L8.2864 18.1943ZM6.02332 20.225L3.77464 16.3302L5.05221 15.5926L7.30088 19.4874L6.02332 20.225Z" fill="#1e2a78" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.0944 6.27857C12.8582 6.27857 11.856 7.28072 11.856 8.51694V9.44718C11.856 9.86139 12.1918 10.1972 12.606 10.1972H18.0111C18.4253 10.1972 18.7611 9.86139 18.7611 9.44718V8.51694C18.7611 7.28072 17.7589 6.27857 16.5227 6.27857H14.0944ZM13.356 8.51694C13.356 8.10915 13.6866 7.77857 14.0944 7.77857H16.5227C16.9305 7.77857 17.2611 8.10915 17.2611 8.51694V8.69718H13.356V8.51694Z" fill="#1e2a78" />
    </svg>
    ,
    name: "Stake Holder",
    key: "stakeholder",
    route: "/stakeholder",
    component: <StakeHolder />,
    noCollapse: true,
    protected: true,
    permissionModule: 'Stackholder'
  },
  {
    type: "collapse",
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(0 0 0)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.25 5C7.83579 5 7.5 5.33579 7.5 5.75V9.75C7.5 10.1642 7.83579 10.5 8.25 10.5H15.75C16.1642 10.5 16.5 10.1642 16.5 9.75V5.75C16.5 5.33579 16.1642 5 15.75 5H8.25ZM9 9V6.5H15V9H9Z" fill="#1e2a78" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.75 2C5.50736 2 4.5 3.00736 4.5 4.25V19C4.5 20.6569 5.84315 22 7.5 22H18.75C19.1642 22 19.5 21.6642 19.5 21.25C19.5 20.8358 19.1642 20.5 18.75 20.5H18V17.5H18.75C19.1642 17.5 19.5 17.1642 19.5 16.75V4.25C19.5 3.00736 18.4926 2 17.25 2H6.75ZM18 16V4.25C18 3.83579 17.6642 3.5 17.25 3.5H6.75C6.33579 3.5 6 3.83579 6 4.25V16.4013C6.44126 16.1461 6.95357 16 7.5 16H18ZM16.5 17.5V20.5H7.5C6.67157 20.5 6 19.8284 6 19C6 18.1716 6.67157 17.5 7.5 17.5H16.5Z" fill="#1e2a78" />
    </svg>
    ,
    name: "Task",
    key: "task",
    collapse: [
      {
        name: "Project Task",
        key: "project-task",
        route: "/project-task",
        component: <EmployeeTask />,
        permissionModule: "Project Task",
      },
      {
        name: "Action Items",
        key: "action-items",
        route: "/action-items",
        component: <MomTask />,
        permissionModule: "Action Items",
      },
      {
        name: 'Bugs',
        key: 'bugs',
        route: '/bugs',
        component: <TaskBugList />,
        permissionModule: "Bugs",
      }
    ],
    protected: true,
  },
  {
    name: "mom View",
    key: "mom-view",
    route: "/meeting-task/mom-view",
    component: <MomView />,
    protected: true,
  },

  {
    name: "View",
    key: "view",
    route: "/stakeholder/view",
    component: <StakeHolderView />,
    protected: true,
  },

];
export default routes;

